import { BucketCompanyCode } from "../../../models/config/BucketCompanyCode";
import { Button, Table } from "react-bootstrap";
import { FaTimesCircle } from "react-icons/fa";
import React from "react";

export type BucketCompanyCodeTableProps = {
    bucketCompanyCodes?: BucketCompanyCode[];
    isPending?: boolean;
    onDelete?: (bucketCompanyCode: BucketCompanyCode) => void;
};

export const BucketCompanyCodeTable = (props: BucketCompanyCodeTableProps) => {
    const { isPending, bucketCompanyCodes, onDelete } = props;

    return (
        <div className="tw-overflow-auto">
            <Table
                className="table-bordered align-middle"
                size="sm"
            >
                <thead>
                    <tr className="table-active thead-light tw-w-full tw-text-center">
                        <th />
                        <th className="nowrap">SID</th>
                        <th className="nowrap">Company Code</th>
                        <th className="nowrap">Company Bucket Code</th>
                    </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={7}>
                                <div className="tw-flex tw-items-center tw-justify-center">
                                    <div className="spinner-border text-primary tw-my-2" />
                                </div>
                            </td>
                        </tr>
                    ) : (
                        bucketCompanyCodes?.map((bucketCompanyCode) => (
                            <tr key={bucketCompanyCode.sid + bucketCompanyCode.company_code}>
                                <td className="tw-whitespace-nowrap align-middle">
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        className="tw-ml-1"
                                        onClick={() => onDelete?.(bucketCompanyCode)}
                                    >
                                        <FaTimesCircle />
                                    </Button>
                                </td>
                                <td className="tw-whitespace-nowrap align-middle">
                                    {bucketCompanyCode.sid}
                                </td>
                                <td className="tw-whitespace-nowrap align-middle">
                                    {bucketCompanyCode.company_code}
                                </td>
                                <td className="align-middle">
                                    {bucketCompanyCode.company_bucket_code}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    )
};